import React, { forwardRef, Ref } from "react";
import classNames from "classnames";

import { OnTabChange } from "types";
import styles from "./Tabs.module.scss";

interface Tab {
    label: string;
    value?: string;
    selectedTab?: string;
    onClick?: OnTabChange;
    children?: React.ReactNode;
    classes?: {
        root?: string;
        button?: string;
    };
}
const Tab = ({ label, value = label, onClick, selectedTab, children, classes }: Tab) => {
    const active = value === selectedTab;
    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (onClick) {
            onClick(e, value);
        }
    };

    return (
        <li
            className={classNames(
                styles["tab-selector__tab"],
                {
                    [styles["tab-selector__tab--active"]]: active,
                },
                classes?.root,
            )}
        >
            <button
                id={label}
                className={classNames(styles["tab-selector__tab-button"], classes?.button, {
                    [styles["tab-selector__tab-button-selected"]]: label === selectedTab,
                })}
                onClick={handleClick}
                role="tab"
                aria-selected={active ? "true" : "false"}
                type="button"
            >
                {children || label}
            </button>
        </li>
    );
};

interface Tabs {
    children: (React.ReactElement<any> | null)[];
    handleChange: OnTabChange;
    selectedTab: string;
    className?: string;
}
const Tabs = forwardRef(
    ({ children, handleChange, selectedTab, className }: Tabs, ref?: Ref<HTMLUListElement>) => {
        return (
            <ul ref={ref} className={classNames(styles["tab-selector"], className)}>
                {React.Children.toArray(children).map(child => {
                    return React.cloneElement(child as React.ReactElement<any>, {
                        onClick: (e: React.MouseEvent<HTMLButtonElement>, newValue: string) =>
                            handleChange(e, newValue),
                        selectedTab,
                    });
                })}
            </ul>
        );
    },
);

export default Tabs;
export { Tab };
